<template>
  <v-card>
    <v-card-text>
      <v-data-table
        @click:row="rowClick"
        single-select
        show-select
        v-model="selectionModel"
        dense
        v-on:item-selected="updateSelection"
        :headers="componentSettingHeaders"
        :items="admin.componentSettingList"
        :items-per-page="15"
        no-data-text="NONE"
        :hide-default-footer="admin.componentSettingList.length == 0"
        :hide-default-header="admin.componentSettingList.length == 0"
      >
        <template v-slot:item.attributeId="{ item }">
          {{ getAttributeName(item.attributeId) }}
        </template>
        <template v-slot:item.required="{ item }">
          <v-icon color="success" v-show="item.required">mdi-check</v-icon>
        </template>
        <template v-slot:item.published="{ item }">
          <v-icon color="success" v-show="item.published">mdi-check</v-icon>
        </template>
      </v-data-table>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn dark color="blue darken-2" @click="addNewComponentSetting"
        ><v-icon>mdi-plus</v-icon> ADD NEW</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    data() {
      return {
        componentSettingHeaders: [
          { text: 'ID', value: 'id', width: '80px' },
          { text: 'ATTRIBUTE', value: 'attributeId' },
          { text: 'LABEL', value: 'label' },
          { text: 'VALUE SUFFIX', value: 'valueSuffix' },
          { text: 'REQUIRED', value: 'required' },
          { text: 'PUBLISHED', value: 'published' }
        ]
      };
    },
    computed: {
      ...mapState(['app', 'admin']),
      selectionModel: {
        get() {
          return this.admin.selectedComponentSettingSelectionModel;
        },
        set(value) {
          this.$store.commit('admin/setSelectionModel', {
            entity: 'selectedComponentSettingSelectionModel',
            value: value
          });
          this.$store.dispatch('admin/getComponentSettingList');
        }
      }
    },
    methods: {
      /**
       * returns the description for given componentId
       */
      getAttributeName(attributeId) {
        return this.admin.attributeList.find((x) => x.id == attributeId)?.name;
      },
      /**
       * Handles row click
       */
      rowClick: function (item, row) {
        row.select(!row.isSelected);
      },
      /**
       * Adds a new Component Attribute to currently selected component
       */
      addNewComponentSetting() {
        this.$store.commit('admin/setSelectedComponentSetting', {
          id: 'new',
          componentId: this.admin.selectedComponent.id,
          attributeId: 0,
          label: '',
          valueSuffix: '',
          published: false
        });
        // clear selection models
        this.clearThisSelectionModel();
      },
      /**
       * Fires when an item is selected in the data table
       */
      updateSelection(data) {
        if (data.value) {
          this.$store.commit('admin/setSelectedComponentSetting', data.item);
        } else {
          this.$store.commit('admin/setSelectedComponentSetting', null);
        }
        this.clearChildSelectionModels();
      },
      /**
       * Clears this components selection model
       */
      clearThisSelectionModel() {
        this.$store.commit('admin/setSelectionModel', {
          entity: 'selectedComponentSettingSelectionModel',
          value: null
        });
      },
      /**
       * Clears Child Selection Models
       */
      clearChildSelectionModels() {
        // placeholder
      }
    }
  };
</script>
